import React from 'react'
import { Link } from 'react-router-dom'

export class Alink extends React.Component {
    render() {
        const children = this.props.children
        let _hostname = ''
        let attr = {}
        if (this.props.href) {
            attr.href = this.props.href
            let slashOf = attr.href.indexOf('//')
            if (slashOf === -1) {
                attr.href = '//'+attr.href
                _hostname = this.props.href.split('/')[0]
            } else if (slashOf === 0) {
                _hostname = this.props.href.split('/')[2]
            }
        }
        if (this.props.target) attr.target = this.props.target
        if (this.props.className) attr.className = this.props.className
        // console.log(window.location.hostname.indexOf('react'))

        if (this.props.target === undefined && window.location.hostname !== _hostname) {
            attr.target = '_blank'
            attr.rel = 'noopener noreferrer'
        }
        return <a {...attr}>{children}</a>
    }
}

export const RouteButton = ({ to, className, children }) => {
    const onClickMenu = () => {
        if (window.location.pathname === to) return
        window.dispatchEvent(new CustomEvent('onHeadRouteChange', { detail: { link: to }}))
    }
    return <Link to={to} type='button' onClick={onClickMenu} className={className}>{ children }</Link>
}



// WEBPACK FOOTER //
// ./src/header/libs/module.js